import { Component, inject, input } from '@angular/core';

import { asyncScheduler, combineLatest, Observable } from 'rxjs';
import { map, observeOn, switchMap } from 'rxjs/operators';

import { AsyncPipe } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { IntegrationMDMPairingService, PairCode } from '@era/locations-sdk';
import { Store } from '@ngrx/store';
import { catchErrorWithToast } from '@rocksoft/shared/toast';
import { PairingCodeComponent } from './pairing-code.component';

@Component({
  selector: 'era-pairing-code',
  templateUrl: './pairing-code.container.html',
  imports: [PairingCodeComponent, AsyncPipe],
})
export class PairingCodeContainerComponent {
  private readonly pairingService = inject(IntegrationMDMPairingService);
  private readonly store = inject(Store);

  public readonly brandId = input.required<string>();
  public readonly locationId = input.required<string>();
  public readonly roomId = input.required<string>();

  public readonly code$: Observable<PairCode | null>;

  constructor() {
    const _brandId$ = toObservable(this.brandId);
    const _locationId$ = toObservable(this.locationId);
    const _roomId$ = toObservable(this.roomId);

    this.code$ = combineLatest([_locationId$, _roomId$, _brandId$]).pipe(
      switchMap(([locationId, roomId, brandId]) =>
        this.pairingService.getPairCode({ locationId, roomId, brandId }).pipe(
          catchErrorWithToast(
            (error) => ({ type: '[PairingCode] Get Pair Code Error', error }),
            'Could not load pairing code'
          ),
          observeOn(asyncScheduler),
          map((result) => {
            if ('toast' in result) {
              this.store.dispatch(result);
              return null;
            }
            return result;
          })
        )
      )
    );
  }
}
